module.exports = __webpack_public_path__ + "assets/ic_badge_01.7fe1032f.svg";